module.exports = __webpack_public_path__ + "static/media/O75-4000.5bfdf0bf.jpg";